module.exports = __webpack_public_path__ + "files/d7282b6095d6cf1e26e7b40dcd0dd6cf.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-2.png
// module id = 1473
// module chunks = 60